import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';

import Header from '../../../common/header'
import Footer from '../../../common/footer'
import SvgIcon from '../../../common/svg-icon/svg-icon'
import { Button, Breadcrumb, } from 'semantic-ui-react'

import '../solar/index.scss'

import Lithiumion from '../../../../assets/images/new-images/Lithiumion.png';
import Solar from '../../../../assets/images/new-images/Solar.png';
import OpticalFiber from '../../../../assets/images/new-images/OpticalFiber.png';
import GreenHydrogen from '../../../../assets/images/new-images/GreenHydrogen.png';
import CarbonFiber from '../../../../assets/images/new-images/CarbonFiber.png';
import UVECuring from '../../../../assets/images/new-images/UVECuring.jpg';
import Semiconductor from '../../../../assets/images/new-images/Semiconductor.jpg';
import AdditiveManufacturing from '../../../../assets/images/new-images/AdditiveManufacturing.jpg';

import 'swiper/css';
import 'swiper/css/pagination';

import { NewInviteUser } from '../../../common/newInviteUser';
import axios from 'axios';
import { BASE_URL } from '../../../../config/config';
import { replaceSpaceInName } from '../../../../common/helperMethods';

import CareesImg from '../../../../assets/images/new-images/careers.jpg';
import Rightsidebar from '../../../common/rightsidebar';
import IndustryValueChain from "../industry-valuechain/industry-valuechain";
import SEO from '../../../../components/seo/SEO';

const AdditiveManufacturingVew = () => {
  const history = useHistory();
  const [CustomerSaysSlidesData, setCustomerSaysSlidesData] = useState([]);
  const [IndustriesData, setIndustriesData] = useState([]);
  const [addManuData, setAddManuData] = useState('');
  const [currentPpage, setCurrentPpage] = useState('3D Printer')

  const [default_industry, setdefault_industry] = useState('')
  const [default_industryID, setdefault_industryID] = useState('')

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'ecosystem', content: 'Ecosystem', link: true, href: '/ecosystem' },
    { key: 'ecosystem', content: 'Additive Manufacturing', link: false },
  ]


  useEffect(() => {
    axios.get(`${BASE_URL}/api/v2/testimonials/list`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setCustomerSaysSlidesData(data)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.get(`${BASE_URL}/api/v2/industries/get`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length > 0) {
        for (let index in data) {
          data[index]['image'] = '';

          if (data[index]['product']['id'] == "SkW9l-VnJRsG") {
            data[index]['image'] = OpticalFiber;
          }

          if (data[index]['product']['id'] == "HJpXxbE2yRjG") {
            data[index]['image'] = UVECuring;
          }

          if (data[index]['product']['id'] == "S1mF5ohWK") {
            data[index]['image'] = GreenHydrogen;
          }

          if (data[index]['product']['id'] == "HkqK_ZLfZvaDX") {
            data[index]['image'] = Semiconductor;
          }

          if (data[index]['product']['id'] == "S1aD-N21Ciz") {
            data[index]['image'] = CarbonFiber;
          }

          if (data[index]['product']['id'] == "rkxIVP6OrI") {
            data[index]['image'] = AdditiveManufacturing;
            setAddManuData(data[index])
          }

          if (data[index]['product']['id'] == "ryh4YXLfWP6DX") {
            data[index]['image'] = Solar;

          }

          if (data[index]['product']['id'] == "SyG_WFgFX") {
            data[index]['image'] = Lithiumion;
          }

        }
      }
      setIndustriesData(data)
      localStorage.setItem('industry_data', JSON.stringify(data));

      setTimeout(() => {

        setdefault_industry(addManuData)
        if (addManuData.product != undefined && addManuData.product.id != undefined) {
          setdefault_industryID(addManuData.product.id)
        }
      }, 1200);
    }).finally(() => {
      //  setLoading(false)
    })



  }, [])


  const gotoAdManu = () => {
    if (addManuData.name != undefined && addManuData.id != undefined) {
      history.push(`/product/${replaceSpaceInName(addManuData.name)}/${addManuData.product.id}`);
    }
  }

  return (
    <>
      <SEO key="ecosystem-additive-manufacturing-seo"
        robots="index, follow"
        canonicalUrl="/ecosystem/additive-manufacturing"
        alternateLink="/ecosystem/additive-manufacturing"
        pageType={'ecosystem'}
        pageContent={{ pageName: 'Explore Additive Manufacturing Technologies & Suppliers', pageDescription: 'Find additive manufacturing technologies, suppliers, and solutions to accelerate production and innovation in AM processes.' }}

      />
      <Header />
      <div className='ecosystempage-view ecosystempage-inners'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>

        <section>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner'>
              <div className='innerpages-left-section'>
                <div className='ecosysteminner-banner'>
                  <img className='banner-img' src={CareesImg} alt='' />
                  <div className='ecosysteminner-inner'>
                    <div className='upper-row'>
                      Additive Manufacturing
                    </div>
                    <p>
                      <b>
                        Powders & Filaments (Metal, Polymer, Composite) → 3D Printing → Post-Processing (Cleaning, Heat Treatment) → Finished Parts
                      </b>
                      <br />
                      Discover technologies, suppliers, and applications across the additive manufacturing value chain.
                      Send RFQs, compare solutions, and stay updated on equipment, materials, and market trends.

                    </p>
                    <div>
                      <Button onClick={() => gotoAdManu()}>Explore </Button>
                    </div>
                  </div>
                </div>
                {addManuData && <IndustryValueChain id={default_industryID} page={currentPpage} curentProd={addManuData} />}
                <section className='mappessubcribe-section'>
                  <div className='mappessubcribe-card'>
                    <div className='mappessubcribe-row'>
                      <h2>Looking To Expand Your Market in <span>3D Printing Sector?</span></h2>
                      <NewInviteUser />
                    </div>
                  </div>
                </section>
              </div>



              {addManuData.product != undefined && addManuData.product.id != undefined && (
                <>
                  <Rightsidebar industry={addManuData.product.id} show={'both'} />
                </>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default AdditiveManufacturingVew